export default __webpack_public_path__ + "c56cb75672aba92a976885d354775679.png";